import { relatedPulseArticles, getPulsePath } from '../../shared/RelatedPulseLinks/relatedPulseArticles.js';

// Shared verbatim page copy. Keep the browser and server response in step.
export const managersItems = [
  {
    heading: true,
    title: 'Key Features',
  },
  {
    title: 'Efficient Club Management',
    description:
      'ShuttleOps simplifies club operations with an easy-to-use interface, ensuring smooth session scheduling, player management, and payment tracking. No more manual tasks or double bookings-everything is automated for you.',
  },
  {
    title: 'Fair Play for Every Player',
    description: 'With our Digital Peg Board, every player gets equal court time based on skill level and availability. This creates a balanced, fair, and enjoyable experience for all members, ensuring no player is left behind.',
  },
  {
    title: 'Seamless Communication',
    description: 'Keep your players informed and engaged with ShuttleOps’ built-in communication hub. Send session reminders, event updates, and important announcements, all from one centralized platform.',
  },
  {
    title: 'Data-Driven Decisions',
    description: 'Gain valuable insights into your club’s performance with detailed analytics and reports. Track player attendance, session stats, and revenue trends to make informed decisions that drive growth and improve player satisfaction.',
  },
  {
    title: 'Scalable and Flexible',
    description: 'Whether you run a small community club or a large organization, ShuttleOps grows with you. The platform is scalable and flexible, adapting to your club’s needs as they evolve, all while maintaining a user-friendly experience.',
  },
  ];

export const managersTimeline = [ 
  { 
    title : "Sign Up and Set Up Your Club",
    description: "Get started by creating your club profile on ShuttleOps. Our simple onboarding process will guide you through setting up your club’s details, uploading player information, and configuring your preferences."
  }, 
  { 
    title: "Automate Court Assignments", 
    description: "Once your club is set up, ShuttleOps takes care of the rest. The Digital Peg Board will automatically assign courts to players based on their skill levels, availability, and the club’s schedule. No need to manually assign courts-let the platform handle it for you."
  }, 
  { 
    title: "Track Attendance and Payments", 
    description: "ShuttleOps tracks player attendance and session payments in real-time. You can monitor who’s attending, collect session fees, and view outstanding payments-all within the platform. Everything is automatically recorded, so you never miss a detail."
  }, 
  { 
    title: "Manage Sessions and Players", 
    description: "With ShuttleOps, managing club sessions has never been easier. Organize your sessions by simply adding details, selecting players, and confirming attendance. Swap players in and out, monitor performance, and keep things running smoothly with minimal effort."
  }, 
  { 
    title: "Communicate with Players", 
    description: "ShuttleOps makes communication seamless. Use the messaging hub to send session reminders, club announcements, or event updates to players. Keep everyone in the loop and ensure no one misses important information."
  }, 
  { 
    title: "Analyze and Improve", 
    description: "After each session, ShuttleOps generates detailed reports and analytics to help you track player performance, attendance, and revenue. Use these insights to make data-driven decisions and continuously improve your club’s operations."
  }
  ];

export const managersHero = "Manage your badminton club more efficiently with ShuttleOps. Designed specifically for club managers, our platform streamlines operations, enhances player experience, and ensures fair play. From automating court assignments to tracking attendance and payments, ShuttleOps takes the hassle out of managing your club.";
export const managersIntroduction = "ShuttleOps brings sessions, fair court rotations, attendance, payments, communications, and reports into one badminton club platform. It reduces routine administration while giving managers and players a clearer view of every club night.";
export const managersQuote = "Working out fair games during a badminton session is always difficult. ShuttleOps makes this so much easier, tracking who has played with whom, so players have a much more varied set of games. I have had lots of positive feedback from players enjoying the greater variety of games.";
export const managersQuoteName = "Martin Hyett";
export const managersQuoteTitle = "Club Manager, Hiltingbury Badminton Club";

export const managersLinks = [
  {
  title: 'Run your first ShuttleOps club session',
  path: '/guides/first-club-session',
  },
  {
  title: 'Playwaze vs ShuttleOps for badminton clubs',
  path: '/compare/playwaze-alternative',
  },
  {
  title: 'Spond vs ShuttleOps for badminton clubs',
  path: '/compare/spond-alternative',
  },
  {
  title: 'SportMember vs ShuttleOps for badminton clubs',
  path: '/compare/sportmember-alternative',
  },
  {
  title: 'Badminton club payment software',
  path: '/badminton-club-payment-software',
  },
];

export const managersCrawlerContent = {
  heading: 'For Club Managers',
  paragraphs: [
  managersHero,
  'Why Club Managers Love ShuttleOps',
  managersIntroduction,
  managersQuote,
  managersQuoteName,
  managersQuoteTitle,
  ...managersItems.flatMap(({ title, description }) => description ? [title, description] : [title]),
  'How It Works',
  ...managersTimeline.flatMap(({ title, description }) => [title, description]),
  ],
  links: [
  ...relatedPulseArticles.managers.map(({ slug, title }) => [getPulsePath(slug), title]),
  ...managersLinks.map(({ path, title }) => [path, title]),
  ],
};
